export const titleLabelAction = (data) => {
    return {
        type: "ADD_TITLE",
        payload: data
    }
}